import { getConfig } from 'config'
import util from 'libs/util'
import { mapGetters, mapActions } from "vuex";
const MAX_COUNT = 60;

export default {
  data() {
    return {
      isCanClick: false,
      codeTime: 0,
      canSend: true,
      showValidCode: false,
      btnText: "获取验证码"
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  created() {
    if (util.getStorage('codeTime')) {
      this.codeTime = util.getStorage('codeTime');
      this.setBtnText();
      this.canSend = false
      this.startTimer()
    }
  },
  methods: {
    goJumpNext() {
      const query = this.$route.query;
      console.log('----nextne4xt----', query);
      const { createdClassesCnt, onlyStudentFlag } = this.getUserInfo;
      if (onlyStudentFlag) {
        this.$gopage('startUpClasses', {isStudent: 1}, true);
      } else {
        if (!createdClassesCnt) this.$gopage('startUpClasses', {}, true);
        else this.$gopage('course_home', {}, true);
        // else this.$user.loginCallBack(query);
      }
    },
    // 返回
    goBack() {
      this.$back()
    },
    // 去登录
    goLogin() {
      this.$gopage('login')
    },
    /**
     * [getCode 获取短信验证码]
     * @return {[type]} [description]
     */
    async getCode() {
      const formData = this.formData;
      if (!this.canSend) {
        return;
      }
      const config = [{
        id: 'mobile',
        rule: {
          required: {
            message: '请输入手机号码'
          },
          mobile: {
            message: '请输入正确的手机号码'
          }
        }
      }];
      let { result, params } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      this.showValidCode = true;
    },
    setBtnText() {
      this.btnText = `${this.codeTime}秒后重试`;
    },
    /**
     * [sendSmsCode 发送短信]
     * @return {[type]} [description]
     */
    async sendSmsCode() {
      const formData = this.formData;
      const params = {};
      this.codeTime = MAX_COUNT;
      this.setBtnText();
      this.canSend = false;
      const res = await this.$post('/passport/sendsms.json', {
        kind: this.smsType,
        mobile: formData.mobile,
        captcha: formData.captcha
      });
      if (res.status != 200) {
        this.timer && clearInterval(this.timer);
        this.codeTime = MAX_COUNT;
        this.btnText = '重新获取';
        this.canSend = true;
        this.timer = null;
        this.formData.captcha = '';
        this.$refs.codeValid && this.$refs.codeValid.clear();
        this.$toast(res.message);
      } else {
        this.showValidCode = false;
        this.setBtnText();
        this.startTimer();
        this.step = 2;
      }
    },
    startTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        --this.codeTime;
        this.setBtnText();
        util.setStorage('codeTime', this.codeTime);
        if (this.codeTime <= 0) {
          clearInterval(this.timer);
          this.btnText = '重新获取';
          this.timer = null;
          this.canSend = true;
          util.setStorage('codeTime', 0);
        }
      }, 1000);
    },
    codeConfirm(val) {
      this.formData.captcha = val;
      this.sendSmsCode();
    }
  }
}